export default __webpack_public_path__ + "static/media/waiting-loop-120.2ba9d333.png";